"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("./SiteFooter.css");

var _Propulator = _interopRequireDefault(require("../../../higher-order/Propulator"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _isNull = _interopRequireDefault(require("lodash/isNull"));

var _RequestDemoButton = _interopRequireDefault(require("../marketing/RequestDemoButton"));

var _CpraScript = _interopRequireDefault(require("../CpraScript"));

var _TrackedLink = _interopRequireDefault(require("../../../gradifui/components/TrackedLink"));

var _SharedContent = require("../cms/SharedContent");

var _constants = require("../../../util/constants");

var _moment = _interopRequireDefault(require("moment/moment"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var SharedItem = (0, _SharedContent.SharedContentItem)("siteFooter");

var SiteFooter = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(SiteFooter, _React$PureComponent);

  var _super = _createSuper(SiteFooter);

  function SiteFooter() {
    _classCallCheck(this, SiteFooter);

    return _super.apply(this, arguments);
  }

  _createClass(SiteFooter, [{
    key: "renderPrivacyLoggedIn",
    value: function renderPrivacyLoggedIn() {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "privacy-logged-in"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "privacy-section"
      }, /*#__PURE__*/_react.default.createElement("a", {
        href: _constants.URLS.MARKETING.PRIVACY_POLICY,
        target: "_blank"
      }, "Privacy Policy"), /*#__PURE__*/_react.default.createElement(_CpraScript.default, null)), /*#__PURE__*/_react.default.createElement("div", {
        className: "terms-section"
      }, /*#__PURE__*/_react.default.createElement("a", {
        href: _constants.URLS.MARKETING.WEBSITE_TERMS,
        className: "website-terms",
        target: "_blank"
      }, "Platform Terms of Use"), /*#__PURE__*/_react.default.createElement("a", {
        href: _constants.URLS.MARKETING.MEMBER_TERMS,
        target: "_blank"
      }, "Member Terms & Conditions")));
    }
  }, {
    key: "renderPrivacyLoggedOut",
    value: function renderPrivacyLoggedOut() {
      return /*#__PURE__*/_react.default.createElement("ul", null, /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("a", {
        href: _constants.URLS.MARKETING.PRIVACY_POLICY,
        target: "_blank"
      }, "Privacy Policy")), /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement(_CpraScript.default, null)), /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("a", {
        href: _constants.URLS.MARKETING.WEBSITE_TERMS,
        target: "_blank"
      }, "Platform Terms of Use")));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props$session, _this$props$session$s, _this$props$session2, _siteFooterModel$memb, _siteFooterModel$memb2, _this$props$session3, _this$props$session3$, _this$props$session4, _this$props$session$g, _this$props$session5, _this$props$externalU, _this$props$externalU2;

      var isLoggedIn = (_this$props$session = this.props.session) === null || _this$props$session === void 0 ? void 0 : _this$props$session.isLoggedIn;
      var siteFooterModel = (_this$props$session$s = (_this$props$session2 = this.props.session) === null || _this$props$session2 === void 0 ? void 0 : _this$props$session2.siteFooterModel) !== null && _this$props$session$s !== void 0 ? _this$props$session$s : {};
      var isMemberPortal = siteFooterModel === null || siteFooterModel === void 0 ? void 0 : siteFooterModel.isMemberPortal;
      var memberSupportEmail = (_siteFooterModel$memb = siteFooterModel === null || siteFooterModel === void 0 ? void 0 : siteFooterModel.memberSupportEmail) !== null && _siteFooterModel$memb !== void 0 ? _siteFooterModel$memb : "";
      var memberSupportNumber = (_siteFooterModel$memb2 = siteFooterModel === null || siteFooterModel === void 0 ? void 0 : siteFooterModel.memberSupportNumber) !== null && _siteFooterModel$memb2 !== void 0 ? _siteFooterModel$memb2 : "";
      var showCpraLink = (_this$props$session3 = this.props.session) === null || _this$props$session3 === void 0 ? void 0 : (_this$props$session3$ = _this$props$session3.featureToggles) === null || _this$props$session3$ === void 0 ? void 0 : _this$props$session3$.cpraFooterLink;
      var requestInfoUrl = (_this$props$session4 = this.props.session) === null || _this$props$session4 === void 0 ? void 0 : _this$props$session4.requestInfoUrl;
      var today = (_this$props$session$g = (_this$props$session5 = this.props.session) === null || _this$props$session5 === void 0 ? void 0 : _this$props$session5.getCurrentUtcNow()) !== null && _this$props$session$g !== void 0 ? _this$props$session$g : (0, _moment.default)();
      var copyrightStringFormatArgs = {
        year: today.year()
      };
      return /*#__PURE__*/_react.default.createElement("footer", {
        className: "site-footer"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "site-footer-content content-wrapper"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "social-content"
      }, /*#__PURE__*/_react.default.createElement("a", {
        className: "logo",
        href: _constants.URLS.HOME
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "footer-logo",
        role: "img",
        "aria-label": "Gradifi"
      })), /*#__PURE__*/_react.default.createElement("a", {
        href: (_this$props$externalU = (_this$props$externalU2 = this.props.externalUrls) === null || _this$props$externalU2 === void 0 ? void 0 : _this$props$externalU2.linkedIn) !== null && _this$props$externalU !== void 0 ? _this$props$externalU : "",
        target: "_blank"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "linkedin-logo",
        role: "img",
        alt: "Follow us on LinkedIn"
      }))), /*#__PURE__*/_react.default.createElement("div", {
        className: "link-content"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: (0, _classnames.default)("static-columns", {
          "employer-portal": !isMemberPortal && isLoggedIn
        })
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "link-column products-column"
      }, /*#__PURE__*/_react.default.createElement("ul", null, /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("h4", null, "Products")), /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement(_TrackedLink.default, {
        eventLabel: "footer-refi",
        href: _constants.URLS.MARKETING.REFI,
        target: "_blank"
      }, "FinancialCore")), /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement(_TrackedLink.default, {
        eventLabel: "footer-student-loan-paydown",
        href: _constants.URLS.MARKETING.PAYDOWN,
        target: "_blank"
      }, "Student Loan PayDown")), /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement(_TrackedLink.default, {
        eventLabel: "footer-saveup",
        href: _constants.URLS.MARKETING.SAVEUP,
        target: "_blank"
      }, "College SaveUp")))), /*#__PURE__*/_react.default.createElement("div", {
        className: "link-column about-column"
      }, /*#__PURE__*/_react.default.createElement("ul", null, /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("h4", null, "About")), /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("a", {
        target: "_blank",
        href: _constants.URLS.MARKETING.CAREERS
      }, "Careers")), /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("a", {
        href: _constants.URLS.MARKETING.CONTACT,
        target: "_blank"
      }, "Contact"))))), isMemberPortal && /*#__PURE__*/_react.default.createElement("div", {
        className: "link-column member-support-column"
      }, /*#__PURE__*/_react.default.createElement("ul", null, /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("h4", null, "Member Support")), !(0, _isNull.default)(memberSupportNumber) && /*#__PURE__*/_react.default.createElement("li", {
        className: "member-support-phone"
      }, "Phone: ", /*#__PURE__*/_react.default.createElement("a", {
        href: "tel:+" + memberSupportNumber
      }, "(844) GRADIFI (472-3434)")), !(0, _isNull.default)(memberSupportEmail) && /*#__PURE__*/_react.default.createElement("li", {
        className: "member-support-email"
      }, "Email: ", /*#__PURE__*/_react.default.createElement("a", {
        href: "mailto:membersupport@gradifi.com?subject=Gradifi member support question"
      }, memberSupportEmail)), /*#__PURE__*/_react.default.createElement("li", null, "Hours of Support: Monday - Friday 8:00 AM to 8:00 PM EST"))), !isLoggedIn && /*#__PURE__*/_react.default.createElement("div", {
        className: "link-column demo-column demo-login-content"
      }, /*#__PURE__*/_react.default.createElement("ul", null, /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement(_RequestDemoButton.default, {
        url: requestInfoUrl
      })), /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("a", {
        href: _constants.URLS.LOGIN
      }, "Login/Register")))))), /*#__PURE__*/_react.default.createElement("div", {
        className: "privacy-terms-row content-wrapper"
      }, !showCpraLink && /*#__PURE__*/_react.default.createElement("ul", null, /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("a", {
        href: _constants.URLS.MARKETING.PRIVACY_POLICY,
        target: "_blank"
      }, "Privacy")), /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("a", {
        href: _constants.URLS.MARKETING.WEBSITE_TERMS,
        target: "_blank"
      }, "Platform Terms of Use")), isLoggedIn && /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("a", {
        href: _constants.URLS.MARKETING.MEMBER_TERMS,
        target: "_blank"
      }, "Member Terms & Conditions"))), showCpraLink && !isLoggedIn && this.renderPrivacyLoggedOut(), showCpraLink && isLoggedIn && this.renderPrivacyLoggedIn()), /*#__PURE__*/_react.default.createElement("div", {
        className: "disclosure-row content-wrapper"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "disclosure-items"
      }, /*#__PURE__*/_react.default.createElement(SharedItem, {
        tag: "p",
        contentKey: "disclaimer1_v3"
      }), /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement(SharedItem, {
        tag: "p",
        contentKey: "disclaimer2_v3"
      })), /*#__PURE__*/_react.default.createElement("div", {
        className: "disclosure-items"
      }, /*#__PURE__*/_react.default.createElement(SharedItem, {
        tag: "p",
        contentKey: "disclaimer5_v3"
      }), /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement(SharedItem, {
        tag: "p",
        contentKey: "disclaimer6_v3"
      }), /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement(SharedItem, {
        tag: "p",
        contentKey: "copyright_v4",
        stringFormatArgs: copyrightStringFormatArgs
      }))));
    }
  }]);

  return SiteFooter;
}(_react.default.PureComponent);

var _default = (0, _Propulator.default)(SiteFooter, {
  sessionStore: ["session", "externalUrls"]
});

exports.default = _default;